import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Header from "../components/Header";
import "../styles/PartnerPage.css";

export default function RespitePartnershipPage() {
  return (
    <>
      <Header />

      <main className="partner-page partner-page--respite">
        {/* HERO */}
        <section className="partner-hero">
          <Container>
            <Row className="align-items-center">
              <Col lg={7}>
                <h1 className="partner-hero__title">
                  Bath–Brunswick Respite Care Partnership
                </h1>
                <p className="partner-hero__tagline">
                  Giving people living with memory loss a place to belong —
                  and giving caregivers time to breathe.
                </p>
                <div className="partner-hero__actions">
                  <a href="#how-we-partner" className="partner-hero__link">
                    How we&apos;ll partner →
                  </a>
                  <Button
                    variant="primary"
                    className="partner-hero__donate"
                    href="#donate"
                  >
                    Support respite care
                  </Button>
                </div>
              </Col>

              <Col lg={5} className="partner-hero__logo-col">
                <div className="partner-hero__logo-card partner-hero__logo-card--photo">
                  <img
                    src="/img/club.jpeg"
                    alt="Guests and staff at Bath–Brunswick Respite Care's Adult Day Program"
                    className="partner-hero__logo partner-hero__logo--photo"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* WHO THEY ARE */}
        <section className="partner-section">
          <Container>
            <Row>
              <Col lg={{ span: 8, offset: 2 }}>
                <h2 className="partner-section__heading">
                  What Is Bath–Brunswick Respite Care &quot;The Club&quot;?
                </h2>
                <p className="partner-section__body">
                  Bath–Brunswick Respite Care is a nonprofit serving midcoast
                  Maine families who are caring for loved ones with
                  Alzheimer&apos;s disease and other forms of dementia. Their
                  Adult Day Program, known as &quot;The Club,&quot; offers a
                  safe, structured place where guests can spend the day with
                  friends instead of feeling isolated at home.
                </p>
                <p className="partner-section__body">
                  While guests enjoy conversation, music, games, and shared
                  meals in a warm, familiar setting, family caregivers get a
                  reliable block of time to rest, work, run errands, or simply
                  recharge. It&apos;s real, practical support that keeps people
                  living with memory loss at home longer and eases the strain on
                  the families who love them.
                </p>
                <p className="partner-section__body partner-section__body--link">
                  Learn more about their work at{" "}
                  <a
                    href="https://www.respite-care.org/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    respite-care.org
                  </a>
                  .
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* WHAT THEY DO FOR PEOPLE WITH ALZHEIMER’S */}
        <section className="partner-section partner-section--alt">
          <Container>
            <Row>
              <Col lg={{ span: 8, offset: 2 }}>
                <h2 className="partner-section__heading">
                  How &quot;The Club&quot; Supports People Living with Dementia
                </h2>
                <p className="partner-section__body">
                  Most guests at The Club are living with Alzheimer&apos;s or
                  related dementias. Each day is built around gentle structure:
                  welcoming coffee, group conversation, brain games and
                  reminiscence activities, arts and crafts, music, and movement
                  tailored to different abilities.
                </p>
                <p className="partner-section__body">
                  These interactions aren&apos;t just a way to pass the time.
                  Regular social connection, conversation, and cognitive
                  stimulation can help maintain a person&apos;s abilities and
                  mood, even as the disease progresses. Just as importantly, The
                  Club gives caregivers a dependable respite. Knowing their
                  loved one is safe, engaged, and cared for makes it easier to
                  handle the demands of long-term caregiving.
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* HOW WE WILL PARTNER */}
        <section className="partner-section" id="how-we-partner">
          <Container>
            <Row>
              <Col lg={{ span: 8, offset: 2 }}>
                <h2 className="partner-section__heading">
                  How the Gail Thompson Foundation Will Partner with The Club
                </h2>

                <p className="partner-section__body">
                  Our family knows firsthand how much a few hours of reliable
                  respite can mean when you&apos;re caring for someone with
                  Alzheimer&apos;s. Through this partnership, the Gail Thompson
                  Foundation wants to help keep programs like The Club strong,
                  welcoming, and accessible to families in our community.
                </p>

                <ul className="partner-list">
                  <li>
                    <strong>Supporting day-to-day programming.</strong> A
                    portion of funds will help cover the cost of daily
                    activities—everything from art supplies and games to music,
                    seasonal celebrations, and shared meals that make each visit
                    feel special.
                  </li>
                  <li>
                    <strong>Helping families access respite.</strong> When
                    possible, we hope to contribute to caregiver assistance
                    funds or &quot;scholarship&quot; support so that cost is
                    less of a barrier for families who need regular respite
                    care.
                  </li>
                  <li>
                    <strong>Showing up as a team.</strong> We also plan to
                    explore hands-on volunteer opportunities for the Bowdoin
                    Baseball community—everything from helping with events to
                    organizing activity days or small facility projects that
                    make the space even more welcoming.
                  </li>
                </ul>

                <p className="partner-section__body">
                  When you give to the Gail Thompson Foundation, you&apos;re not
                  only helping fund research—you&apos;re also making today a
                  little easier for local families living with
                  Alzheimer&apos;s and dementia.
                </p>

                <div className="partner-section__cta">
                  <Button variant="primary" href="#donate">
                    Donate to support respite care
                  </Button>
                  <a href="/" className="partner-section__back-link">
                    ← Back to main fundraiser
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </>
  );
}
